import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addCustomTimes = (pcr: any): IPcr => {
  try {
    const times = pcr?.times

    if (
      times &&
      times.custom1DateTimeLabel === undefined &&
      times.custom1Date === undefined &&
      times.custom1Time === undefined &&
      times.__hideCustom1DateTime === undefined &&
      times.__disableCustom1DateTime === undefined
    ) {
      const defaults: Record<string, string | boolean> = {
        custom1DateTimeLabel: '',
        custom1Date: '',
        custom1Time: '',
        custom2DateTimeLabel: '',
        custom2Date: '',
        custom2Time: '',
        custom3DateTimeLabel: '',
        custom3Date: '',
        custom3Time: '',
        custom4DateTimeLabel: '',
        custom4Date: '',
        custom4Time: '',
        __hideCustom1DateTime: false,
        __hideCustom2DateTime: false,
        __hideCustom3DateTime: false,
        __hideCustom4DateTime: false,
        __disableCustom1DateTime: false,
        __disableCustom2DateTime: false,
        __disableCustom3DateTime: false,
        __disableCustom4DateTime: false,
      }

      Object.keys(defaults).forEach((key) => {
        setValueForPathWithCreate(times, key, defaults[key])
      })
    }

    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addCustomTimes: ${error}`)
    throw error
  }
}
